// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var TaxPolicyListController = function ($scope, TaxPolicy) {
    $scope.taxPolicies = TaxPolicy.query();
};
TaxPolicyListController.$inject = ['$scope', 'TaxPolicy'];
